import { Pipe, PipeTransform } from '@angular/core'
import { camelCase, constantCase, kebabCase, pascalCase } from 'change-case'

type ChangeCaseType = 'camelCase' | 'constantCase' | 'kebabCase' | 'pascalCase'

@Pipe({
    name: 'changeCase',
    standalone: false
})
export class ChangeCasePipe implements PipeTransform {

  public transform(value: string, functionName: ChangeCaseType): string {
    if (!value) {
      return ''
    }

    if (functionName === 'kebabCase') return kebabCase(value)
    if (functionName === 'pascalCase') return pascalCase(value)
    if (functionName === 'constantCase') return constantCase(value)
    return camelCase(value)
  }
}
